import React from 'react';
import Switch from "react-switch";
import { Checkbox, Container, Header, Menu, Segment } from 'semantic-ui-react';
import { PlayButton, Timer, Progress } from 'react-soundplayer/components';
import { withCustomAudio } from 'react-soundplayer/addons';
import "../node_modules/react-soundplayer/styles/icons.css";
import "../node_modules/react-soundplayer/styles/cover.css";
import "./SoundDemoPanel.css";
import "../node_modules/react-soundplayer/styles/volume.css";
// import ReactAudioPlayer from 'react-audio-player';
// require('react-soundplayer/styles/buttons.css');
// require('react-soundplayer/styles/cover.css');

// audio source
// const streamUrl = 'https://assets.coderrocketfuel.com/pomodoro-times-up.mp3';
// const streamUrl = 'https://freesound.org/people/SamsterBirdies/sounds/500586/download/500586__samsterbirdies__laser.wav';
var currentTimeGl = {'keyboard':0, 'crying baby':0, 'barking dog':0, 'children': 0, 'construction':0, 'computer fan': 0};
 
const AWSSoundPlayer = withCustomAudio(props => {
//   const player = <audio src="https://assets.coderrocketfuel.com/pomodoro-times-up.mp3"></audio>
//   <ReactAudioPlayer
//             src=""
//             onListen={updateTime}
//             listenInterval={10}
//             controls
//         />
//   player.audioEl.current.currentTime = 1;
    const { track, currentTime, duration } = props;
    currentTimeGl[props.panelID] = currentTime;
    return (
        <Container >

            <PlayButton style={{height: 50}} {...props} />
            <Progress
                value={(currentTime / duration) * 100 || 0} {...props} />
            <Timer {...props} />
    {/* 
            <div>
                {player}
            </div> */}
        </Container>
  );
});

class SoundDemoPanel extends React.Component {
    constructor(props) {
        super(props);

    }

    state = {toggle: false }

    render() {
        const { toggle } = this.state
        console.log("Toggle: ", toggle);
        console.log("CurrentTimeGl", currentTimeGl)
        var player = null;
        var noise = <AWSSoundPlayer
            streamUrl={this.props.noiseUrl}
            preloadType="auto"
            startTime={currentTimeGl[this.props.panelID]}
            panelID={this.props.panelID} />
        var original = <AWSSoundPlayer
            streamUrl={this.props.originalUrl}
            preloadType="auto"
            startTime={currentTimeGl[this.props.panelID]}
            panelID={this.props.panelID} />
        if (toggle) {
            player = noise;
        } else {
            player = original;
        }


        return (

            <div>
                <Container style={{marginTop: 10, textAlign: 'center'}}>
                    <label>
                    {/* <h4 id="fonts">Noise removal</h4> */}
                    <Switch offColor='#dcdcdc' onColor='#00BFA6' onChange={()=>{this.setState({toggle: !toggle})}} width={100} height={55} checked={toggle} />
                    </label>
                    {/* <Checkbox toggle label="Noise removal" checked={toggle} size={"large"} style={{size: 50}} onChange={()=>{this.setState({toggle: !toggle})}} /> */}
                </Container>
                {player}
            </div>
          )
    }
}

export default SoundDemoPanel